import React from 'react';
import {
  Grid2 as Grid,
  Stack,
  Typography,
} from '@mui/material';

import { displayNoneIfEmptyOrNullString } from '../utilities.js';

const spanLabelStyle = {
  fontWeight: '800'
};

const typographySx = {
  fontSize: '1.1rem'
};

function EncounterHeaderInfo({
  headerInfo
  // subId,
  // mrn,
  // mbi,
  // memberDateOfBirth,
  // dateOfService,
  // renderingProviderName,
  // renderingProviderNpi,
  // claimId,
  // encounterICN
}) {
  return (
    <React.Fragment>
      <Grid alignSelf="flex-start" size={3}>
        <Stack
          direction="column"
          spacing={2}
          sx={{
            alignItems: 'baseline',
            justifyContent: 'flex-start'
          }}
        >
          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>Sub Id:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.subId)
            }
          </Typography>

          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>MRN:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.mrn)
            }
          </Typography>

          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>MBI:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.mbi)
            }
          </Typography>
        </Stack>
      </Grid>

      <Grid alignSelf="flex-start" size={3}>
        <Stack
          direction="column"
          spacing={2}
          sx={{
            alignItems: 'baseline',
            justifyContent: 'flex-start'
          }}
        >
          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>Member DOB:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.memberDateOfBirth)
            }
          </Typography>

          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>DOS:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.dateOfService)
            }
          </Typography>

          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>Rendering Provider Name:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.renderingProviderName)
            }
          </Typography>
        </Stack>
      </Grid>

      <Grid alignSelf="flex-start" size={3}>
        <Stack
          direction="column"
          spacing={2}
          sx={{
            alignItems: 'baseline',
            justifyContent: 'flex-start'
          }}
        >
          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>Rendering Provider Npi:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.renderingProviderNpi)
            }
          </Typography>

          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>Claim Id:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.claimId)
            }
          </Typography>

          <Typography sx={typographySx}>
            <span style={spanLabelStyle}>Encounter ICN:</span> {
              displayNoneIfEmptyOrNullString(headerInfo.encounterICN)
            }
          </Typography>
        </Stack>
      </Grid>
    </React.Fragment>
  );
}

export { EncounterHeaderInfo };
